import { render, staticRenderFns } from "./PlacementsStartComponentReviewAdmin.vue?vue&type=template&id=e7e5fc7e&"
import script from "./PlacementsStartComponentReviewAdmin.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentReviewAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports